export const travelerCount = {
  found_pluralized: ['найден', 'найдено', 'найдено'],
  items: 'путешественники',
  items_pluralized: ['путешественник', 'путешественника', 'путешественников'],
};
